import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { actionRoute } from '../redux/actions';
import Komentar from './Komentar';
import ColumnWidth from './ColumnWidth.js';
import Spinner from './Spinner';
import SpinnerRow from './SpinnerRow';
import SklopiviMini from './SklopiviMini';


const StranaAdminPanel = (props) => {
  const dispatch = useDispatch();

  useEffect(() => {
    // ADMIN PANEL BACKGROUND
    document.body.classList.add("admin-panel");
    return () => {
      // DISMOUNT
      document.body.classList.remove("admin-panel");
    };
  }, []);

  let clicked = (what) => {
    return () => {
      dispatch(actionRoute(what))
    };
  }

  return (
    <>
      <ColumnWidth w={480}>
        <h1>Admin Panel</h1>


        <p><b>NAPOMENA:</b> Administratorske operacije treba raditi tokom "održavanja" (o kojem bi trebalo obavestiti korisnike aplikacije) tj. kada niko od radnika ne koristi aplikaciju i nije otvorena u browseru kod nikog osim jednog administratora. Ukoliko bi se nešto admnistratiorski menjalo na narudžbama i stavkama na kojima neko trenutno radi, moglo bi da dodje do nepredvidjenih problema. <b>To naročito važi za administraciju CNC programa i parametara koja nikako ne bi smela da se vrši van "održavanja".</b></p>
        <p>Nakon završetka "održavanja" aplikaciju je potrebno restartovati tj. uraditi "refresh" <kbd>Ctrl</kbd> + <kbd>F5</kbd> u browseru. To takodje treba uraditi svaki korisnik koji otovir aplikaciju na svojem računaru.</p>
        <p></p>
        <p></p>
        <Komentar>Parametri i CNC programi se keširaju iz namenske baze parametara pri pokretanju aplikacije i promene istih se ne pojavljuju u aplikaciji sve do restarta/refresh-a, tako da bi administracija pomenutih van "održavanja" neminovno uzrokovala greške u smislu nekonzistentnosti.</Komentar>

        <h2>Sekcije admin panela</h2>
        <p>Admin panel sada pokriva sledeće celine:</p>
        <p><a href="#" onClick={clicked('ADMIN_USERS')}>Administracija Korisnika</a></p>
        <p><a href="#" onClick={clicked('ADMIN_TER_COMORDER')}>Administracija Narudžbi</a></p>
        <p><a href="#" onClick={clicked('ADMIN_TER_COMORDITEM')}>Administracija Stavki Narudžbi</a></p>
        <p><a href="#" onClick={clicked('ADMIN_LIB_TER_CONST')}>Administracija biblioteke Termovent Konstanta</a></p>
        <p><a href="#" onClick={clicked('ADMIN_LIB_CPARAMS')}>Admin Panel Biblioteka default cparams</a></p>
        <p><a href="#" onClick={clicked('ADMIN_LIB_MATERIJAL_LIM')}>Administracija biblioteke Materijal Lim</a></p>
        <p><a href="#" onClick={clicked('ADMIN_LIB_CNC_S4_TEMPLATE')}>Administracija biblioteke CNC program S4 templatea</a></p>
        <p><a href="#" onClick={clicked('ADMIN_LIB_DOCUMENT')}>Administracija biblioteke tabela</a></p>
        <p><a href="#" onClick={clicked('ADMIN_LIB_TER_CONST')}>Administracija biblioteke Termovent Konstanta</a></p>
        <p><a href="#" onClick={clicked('ADMIN_DINAMICKAF')}>Administracija dinamičke funkcionalnosti</a></p>
        <p><a href="#" onClick={clicked('ADMIN_RADNICENTRI')}>Administracija radni centri</a></p>


        <br />
        <p>Nisu još puštene u rad:</p>
        <p>Administracija biblioteke Termovent Konstanta...</p>

        <br />
        <br />
        <Spinner />
        <SpinnerRow />

        <p></p>
        <p></p>

        <SklopiviMini title={'BAZA prikaz'}>
          ...
        </SklopiviMini>
        <p></p>
        <p></p>

      </ColumnWidth>
    </>
  );
};

export default StranaAdminPanel;